import React from 'react';

export const BookShelfSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
      {Array.from({ length: 10 }).map((_, i) => (
        <div key={i} className="flex flex-col gap-3 animate-pulse">
          <div className="aspect-[2/3] w-full bg-slate-200 dark:bg-slate-800 rounded-xl" />
          <div className="h-4 w-3/4 bg-slate-200 dark:bg-slate-800 rounded-md" />
          <div className="h-3 w-1/2 bg-slate-200 dark:bg-slate-800 rounded-md" />
        </div>
      ))}
    </div>
  );
};

export const FlashcardSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="w-full h-40 bg-slate-200 dark:bg-slate-800 rounded-[24px] animate-pulse" />
      ))}
    </div>
  );
};

export const FeedSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-6">
      {Array.from({ length: 5 }).map((_, i) => (
        <div key={i} className="w-full h-64 bg-slate-200 dark:bg-slate-800 rounded-[24px] animate-pulse" />
      ))}
    </div>
  );
};
